import axios from 'axios';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { BASE_URL } from '../../config/axios';
import { ToastContainer, toast } from "react-toastify";
import { AddwithWhiteCircle, DeleteDustbin, Road, SearchBig, Tires, Truckbody, UpdatePencil } from '../AllSvg';
import { handleErrorToast } from '../custom';
import { Modal } from 'react-bootstrap';


const WorktypeCU = ({ getData, usedFor, i }) => {
    const [formData, setFormData] = useState({
        title: '',
        company_id: '08d19069-5ffe-4a44-ad34-405ad7633954',
    });

    const [isSubmitted, setIsSubmitted] = useState(false);

    const [show, setShow] = useState(false);

    const handleShow = () => {

        setShow(true);
        if (usedFor === "Update") {
            setFormData(i);
        }
    }

    const handleClose = () => {
        setShow(false);

        setFormData({
            title: '',
            company_id: "08d19069-5ffe-4a44-ad34-405ad7633954"
        })
        setErrors({});
    }

    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        if (!formData.title || formData.title.trim() === "") {
            newErrors.title = "WorkType name is a required field.";
        }

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };



    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            setLoading(true); //loading logic
            try {

                const url = usedFor === "Add" ? await axios.post(`${BASE_URL}/project/worktype/`, formData) : await axios.put(`${BASE_URL}/project/worktype/${i.id}/`, formData)

                let res = url

                if (res.status === usedFor === "Add" ? "201" : "200") {
                    getData();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success(`WorkType Data ${usedFor === "Add" ? "Added" : "Updated"} successfully!`);

                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }

        }
    };





    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value,
        });

        setFormData({
            ...formData,
            [name]: value,
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };



    return (
        <>
            <button className={usedFor === "Add" ? 'upload-svg' : 'model-edit-button-new'} onClick={handleShow}>
                {usedFor === "Add" ?
                    <>
                        <AddwithWhiteCircle /> {"Worktype Name"}
                    </>
                    : <UpdatePencil />
                }
            </button>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>{usedFor === "Add" ? "Add" : "Update"} WorkType Name</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <form>
                            <div className='form-flex-wrap' style={{ justifyContent: "space-between" }}>

                                <div className="flex-column ">
                                    <label className="form-labels">WorkType Name:<span className="required">*</span></label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        placeholder="WorkType Name"
                                        onChange={handleInputChange}
                                        className={`form-input width-15vw ${errors.title ? 'error' : inputState.title ? 'success' : ''}`}
                                        style={{ width: "18vw" }}
                                    />
                                    {errors.title && <span className="error-message">{errors.title}</span>}
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
                <div className="button-models-gap-116 " style={{ marginBottom: "20px" }} >
                    <div className="">
                        <button type="button" onClick={handleClose} className="model-button-cancel model-button   font-weight500  ">Cancel</button>
                    </div>

                    <div className="">
                        <button onClick={handleSubmit} className="model-button model-button-submit">{usedFor === "Add" ? "Submit" : "Update"}</button>
                    </div>

                </div>
            </Modal>
        </>
    );
};

const DeleteWorkType = ({ i, getData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/project/worktype/${i.id}/`
            );

            if (res.status === 200) {
                await getData();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("Data deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete WorkType"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete WorkType of "{i.title}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete WorkType ?
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    model-button-cancel "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const WorkType = ({ worktypeName, buffer, getData }) => {

    const [searchQuery, setSearchQuery] = useState("");


    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div >
                <div className="attendance-box">
                    <div className="datagrid-container">
                        <div className="custom-table-background" style={{ height: "66vh" }}>
                            <div className="">
                                <div className="">
                                    <div className="table-box ">
                                        <div className="flex-row table-heading" style={{ justifyContent: "end" }}>

                                            <WorktypeCU getData={getData} usedFor="Add" />
                                        </div>
                                    </div>
                                    <div className='table-box scroll-container-table'
                                    >
                                        <table className="table-css width-100vw">
                                            <thead className="table-heading">
                                                <tr className="custom-table-head-tr">
                                                    <th className="table-heading ">S.no.</th>
                                                    <th className="table-heading text-left">Company Name</th>
                                                    <th className="table-heading text-left">WorkType Name</th>
                                                    <th className="table-heading text-end">Action</th>
                                                </tr>
                                            </thead>
                                            {buffer ? (

                                                <div className="spinner-bgdatil"></div>

                                            ) :
                                                <tbody>
                                                    {
                                                        worktypeName
                                                            ?.filter((e) =>
                                                                e.title?.toLowerCase().includes(searchQuery.toLowerCase())
                                                            )
                                                            .sort((a, b) =>
                                                                a.title?.localeCompare(b.title, "en", { ignorePunctuation: true })
                                                            )
                                                            .map((i, index) => (
                                                                <tr key={index} className="custom-table-head-td">
                                                                    <td className="table-body ">{index + 1}.</td>
                                                                    <td className="table-body text-left">{i.company?.title}</td>
                                                                    <td className="table-body text-left">{i.title}</td>
                                                                    <td className="table-body justify-end flex-row">
                                                                        <WorktypeCU usedFor="Update" i={i} getData={getData} />
                                                                        <DeleteWorkType i={i} getData={getData} />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                    }
                                                </tbody>
                                            }
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WorkType;